import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PublicAppSection } from '../../core/store/ui/ui.state';
import { Store } from '@ngrx/store';
import { fromStore } from '../../core/store';
import { selectUiState } from '../../core/store/reducers';
import { Vendor } from '../../core/models/entities/vendor';

@Component({
  selector: 'app-footer',
  template: `
    <div class="bg-secondary-900 py-20 text-white">
      <div class="container">
        <div class="grid grid-cols-1 lg:grid-cols-3">
          <div *ngIf="vendor$ | async; else ercosInfo" class="col-span-1">
            <div class="font-bold uppercase">{{ (vendor$ | async)?.name }}</div>
            <div>{{ (vendor$ | async)?.address }}</div>
            <div
              >{{ (vendor$ | async)?.zip }} {{ (vendor$ | async)?.city }}</div
            >
          </div>
          <ng-template #ercosInfo>
            <div class="col-span-1">
              <a href="https://www.ercos.ch" target="_blank">
                <img
                  class="w-14"
                  src="/assets/img/ercos-gris.svg"
                  alt="Développé par Ercos SA"
                  title="Développé par Ercos SA"
                />
              </a>
              <div class="pt-3 font-bold uppercase">Ercos SA</div>
              <div>Chemin en Cormistaux 92A</div>
              <div>1040 Echallens</div>
            </div>
          </ng-template>
          <div class="col-span-1 mt-8 flex lg:mt-0 lg:justify-center">
            <div *ngIf="B2C$ | async">
              <div
                ><a
                  *ngIf="(vendor$ | async)?.general_terms_public_url"
                  [href]="(vendor$ | async)?.general_terms_public_url"
                  target="_blank"
                  >Conditions générales</a
                ></div
              >
              <div
                ><a
                  [routerLink]="[
                    '/louer-salle',
                    (vendor$ | async)?.slug,
                    'politique-confidentialite',
                  ]"
                  >Politique de confidentialité</a
                ></div
              >
              <div
                ><a
                  href="javascript:void(0);"
                  class="biskoui-button-show-banner"
                  >Paramètres de confidentialité</a
                ></div
              >
            </div>
            <div *ngIf="(B2C$ | async) === false">
              <div
                ><a routerLink="/conditions-generales" target="_blank"
                  >Conditions générales</a
                ></div
              >
              <div
                ><a routerLink="/politique-confidentialite" target="_blank"
                  >Politique de confidentialité</a
                ></div
              >
              <div
                ><a
                  href="javascript:void(0);"
                  class="biskoui-button-show-banner"
                  >Paramètres de confidentialité</a
                ></div
              >
              <div
                ><a routerLink="/permissions">Rôles et droits d'accès</a></div
              >
            </div>
          </div>

          <div
            *ngIf="vendor$ | async; else ercosContactDetails"
            class="col-span-1 mt-8 flex lg:mt-0 lg:justify-end"
          >
            <div class="space-y-2">
              <div *ngIf="(vendor$ | async)?.email">
                <a
                  class="no-underline"
                  href="mailto:{{ (vendor$ | async)?.email }}"
                >
                  <i class="fal fa-paper-plane mr-1"></i>
                  {{ (vendor$ | async)?.email }}
                </a>
              </div>
              <div *ngIf="(vendor$ | async)?.phone">
                <a
                  class="no-underline"
                  href="tel:{{ (vendor$ | async)?.phone }}"
                >
                  <i class="fal fa-phone mr-1"></i>
                  {{ (vendor$ | async)?.phone }}
                </a>
              </div>
            </div>
          </div>
          <ng-template #ercosContactDetails>
            <div class="col-span-1 mt-8 flex lg:mt-0 lg:justify-end">
              <div>
                <div><a routerLink="/auth/devenir-un-hote">Devenir hôte</a></div>
                <div><a routerLink="/louer-ma-salle/partenaires-revendeurs">Devenir revendeur</a></div>
                <div><a routerLink="/louer-salle">Rechercher une salle</a></div>
                <div><a routerLink="/louer-ma-salle/contact">Contact</a></div>
                <div class="mt-4">
                  <a routerLink="/auth/connexion">
                    <app-button variant="dark" [pill]="true">Se connecter</app-button>
                  </a>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div *ngIf="B2C$ | async" class="mt-10 text-sm">
          <div
            >Les salles louées par l'intermédiaire de ce site sont gérées et
            facturées par : {{ (vendor$ | async)?.name }}.
          </div>
          <div class="mt-1"
            >Développé par
            <a href="https://www.ercos.ch" target="_blank">Ercos SA</a>.</div
          >
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class FooterComponent implements OnInit {
  B2C$: Observable<boolean> = this.store
    .select(fromStore.selectPublicAppSection)
    .pipe(
      map((publicAppSection: PublicAppSection) => {
        return publicAppSection === PublicAppSection.B2C;
      }),
    );
  vendor$: Observable<Vendor | null> = this.store
    .select(selectUiState)
    .pipe(
      map((uiState) =>
        uiState.publicAppSection === PublicAppSection.B2C
          ? uiState.vendor
          : null,
      ),
    );

  constructor(private store: Store) {}

  ngOnInit(): void {}
}
